module.exports = __webpack_public_path__ + "img/Spotify.204238db.svg";